import { reactive, readonly, ref } from 'vue'
import { FormInstance } from 'element-plus'
import { ReportCreationModeType } from '@/widgets/WReportCreation/types/reportCreation.types'
import {
  PatientInfoType,
  PatientType,
  ImagesRotationsType,
  UploadFileRotate,
} from '@/shared/types'
import { REPORT_CREATION_MODE } from '@/widgets/WReportCreation/constants/reportCreation'
import { getDateFormat } from '@/shared/utils'
import { DATE_FORMAT } from '@/shared/constants'

const reportCreationMode = ref<ReportCreationModeType>(
  REPORT_CREATION_MODE.nullPatient
)
const selectedPatient = ref<PatientType>()
const patientCreationForm = ref<FormInstance>()
const isPigmentedPlaque = ref(false)
const receiptDate = ref(getDateFormat(new Date(), DATE_FORMAT.ymdDash))
const teethStone = ref<number[]>([])
const images = ref<UploadFileRotate[]>([])
const teethCaries = ref<string | null>('')
const teethFilling = ref<string | null>('')
const teethExtracted = ref<string | null>('')

const patientCreationFormData: PatientInfoType = reactive({
  surname: '',
  name: '',
  patronymic: '',
  date: '',
  email: '',
  cartNumber: '',
  phone: '',
})

export const useReportCreation = (): any => {
  const getImagesFiles = () => {
    return images.value.map((image) => image.raw)
  }

  const getImagesRotations = () => {
    const images_rotations: ImagesRotationsType = {}
    images.value.forEach((image) => {
      images_rotations[image.name] = (image.degree / 90) % 4
    })

    return images_rotations
  }

  const setSelectedPatient = (patient: PatientType): void => {
    selectedPatient.value = patient
  }

  const resetData = (): void => {
    reportCreationMode.value = REPORT_CREATION_MODE.nullPatient
    patientCreationForm.value?.resetFields()
    selectedPatient.value = {} as PatientType
    isPigmentedPlaque.value = false
    receiptDate.value = getDateFormat(new Date(), DATE_FORMAT.ymdDash)
    teethStone.value = []
    images.value = []
    teethCaries.value = ''
    teethFilling.value = ''
    teethExtracted.value = ''
  }

  return {
    selectedPatient: readonly(selectedPatient),
    patientCreationForm,
    reportCreationMode,
    isPigmentedPlaque,
    receiptDate,
    teethStone,
    images,
    patientCreationFormData,
    getImagesFiles,
    getImagesRotations,
    setSelectedPatient,
    resetData,
    teethCaries,
    teethFilling,
    teethExtracted,
  }
}
export { UploadFileRotate }
